import { Reveal } from "../components/Reveal";
import { EMAIL, PHONE, PHONE_TEL, usePageMeta } from "../lib/api";

const SECTIONS = [
  {
    title: "Our commitment",
    body: "Show Me Shield is committed to making this website usable by everyone, including people who use screen readers, keyboard navigation, or other assistive technology. We aim for WCAG 2.1 AA conformance across the site.",
  },
  {
    title: "What we do",
    body: "Every form field has a visible label, interactive elements have visible keyboard focus states, images carry descriptive alt text, color contrast meets or exceeds WCAG AA targets, motion respects your reduced-motion system setting, and every page can be navigated without a mouse.",
  },
  {
    title: "Known limits",
    body: "This site is actively maintained and improved. If something isn't working for you, that's on us to fix — not on you to work around.",
  },
  {
    title: "Get help",
    body: `If you have trouble using any part of this site, call us at ${PHONE} or email ${EMAIL}. A real person will help you directly — no forms required.`,
  },
];

const Accessibility = () => {
  usePageMeta("Accessibility | Show Me Shield", "Show Me Shield's commitment to an accessible website for every visitor, and how to reach us if something doesn't work for you.", { path: "/accessibility" });

  return (
    <main className="bg-paper">
      <div className="border-b border-ink/10 bg-ink">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
          <Reveal>
            <p className="eyebrow mb-3">Accessibility</p>
            <h1 className="h-display text-4xl text-white sm:text-5xl">Built for every visitor.</h1>
          </Reveal>
        </div>
      </div>
      <div className="mx-auto max-w-4xl space-y-10 px-4 py-16 sm:px-6">
        {SECTIONS.map((s) => (
          <Reveal key={s.title}>
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-ink">{s.title}</h2>
            <p className="mt-3 text-base leading-relaxed text-primer">{s.body}</p>
          </Reveal>
        ))}
        <p className="text-sm text-primer">
          Prefer the phone?{" "}
          <a href={PHONE_TEL} data-testid="accessibility-phone-link" className="font-mono font-bold text-ink underline decoration-lime decoration-2">
            {PHONE}
          </a>
        </p>
      </div>
    </main>
  );
};

export default Accessibility;
